import { mapState } from "vuex";

export function buildTrainingCategoryTree(parents, children) {
  return (parents || []).map((parent) => ({
    value: String(parent.value),
    label: parent.label,
    children: (children || [])
      .filter((child) => String(child.value).startsWith(String(parent.value) + "/"))
      .map((child) => ({
        value: String(child.value),
        label: child.label
      }))
  }));
}

export function trainingCategoryText(value, tree) {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  const text = String(value);
  for (const parent of tree || []) {
    if (text === String(parent.value)) {
      return parent.label;
    }
    for (const child of parent.children || []) {
      if (text === String(child.value)) {
        return parent.label + "/" + child.label;
      }
    }
  }
  return text;
}

export default {
  computed: {
    ...mapState({
      newTrainingCategoryParents: (state) => state.enumMap.NEW_TRAINING_CATEGORY || [],
      newTrainingCategoryChildren: (state) => state.enumMap.NEW_TRAINING_SUB_CATEGORY || []
    }),
    trainingCategoryTree() {
      return buildTrainingCategoryTree(
        this.newTrainingCategoryParents,
        this.newTrainingCategoryChildren
      );
    }
  },
  data() {
    return {
      categoryCascaderProps: { emitPath: false },
      categoryFilterProps: { emitPath: false, checkStrictly: true }
    };
  },
  watch: {
    trainingCategoryTree() {
      if (!this.form || !Object.prototype.hasOwnProperty.call(this.form, "category")) {
        return;
      }
      const next = this.normalizeLeafCategory(this.form.category);
      if (next !== this.form.category) {
        this.form.category = next;
      }
    }
  },
  methods: {
    trainingCategoryText(value) {
      return trainingCategoryText(value, this.trainingCategoryTree);
    },
    normalizeLeafCategory(value) {
      const text = value == null ? "" : String(value);
      if (!text) {
        return "";
      }
      const tree = this.trainingCategoryTree || [];
      if (!tree.length) {
        return text;
      }
      for (const parent of tree) {
        for (const child of parent.children || []) {
          if (String(child.value) === text) {
            return text;
          }
        }
      }
      return "";
    }
  }
};
